export class ContentDarkSite {
  isEnabled: any;
  level: any;
  enableBlackTheme: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['isEnabled']) {
        this.isEnabled = contentjson['isEnabled'];
      }
      if (contentjson['level']) {
        this.level = contentjson['level'];
      }
      if (contentjson['enableBlackTheme']) {
        this.enableBlackTheme = contentjson['enableBlackTheme'];
      }
    } else {
      this.isEnabled = null;
      this.level = null;
      this.enableBlackTheme = null;
    }
  }
}
